import { IApiGateway } from '@/modules/api/api.interface'

import { ITagRepository } from './tag.repository.interface'
import { CreateTagSchema, TagQueryParamsSchema, UpdateTagSchema } from './tag.schema'
import { TagResponseDto, TagSearchByNameResponseDto } from './tag.types'

export class TagRepository implements ITagRepository {
  constructor(private api: IApiGateway) {}

  async getAll(): Promise<TagResponseDto[]> {
    return this.api.get<TagResponseDto[]>('tags')
  }

  async get(tagId: string, filters: TagQueryParamsSchema): Promise<TagResponseDto> {
    return this.api.get<TagResponseDto>(`tags/${tagId}`, {
      params: {
        ...filters,
      },
    })
  }

  async update(tagId: string, data: UpdateTagSchema): Promise<TagResponseDto> {
    return this.api.put<TagResponseDto, UpdateTagSchema>(`tags/${tagId}`, data)
  }

  async create(data: CreateTagSchema): Promise<TagResponseDto> {
    return this.api.post<TagResponseDto, CreateTagSchema>('tags', data)
  }

  async searchByName(name: string): Promise<TagSearchByNameResponseDto[]> {
    return this.api.get<TagSearchByNameResponseDto[]>('tags/search-by-name', {
      params: {
        name,
      },
    })
  }
}
